import React from 'react';
import HeroIndustrial from '../industrial/HeroIndustrial';
import TestimonialsIndustrial from '../industrial/TestimonialsIndustrial';
import ContactIndustrial from '../industrial/ContactIndustrial';
import SEO from '../SEO';
import { organizationSchema } from '../../utils/structuredData';

const HomePage: React.FC = () => {
  return (
    <>
      <SEO
        title="Junisama | Alquiler de Baños Portátiles en Colombia | Servicio Premium 24/7"
        description="Alquiler de baños portátiles para eventos en Colombia. Unidades VIP, estándar, eléctricos y para discapacitados. Más de 10 años sirviendo festivales, bodas y eventos corporativos. Operarios certificados. Cobertura Bogotá, Medellín. ☎ +57 350 708 9584"
        keywords="baños portátiles Colombia, alquiler baños portátiles Bogotá, alquiler sanitarios Medellín, baños portátiles eventos, baños VIP portátiles, trailer lujo, lavamanos portátiles, baños discapacitados, operarios certificados, puntos ecológicos, Junisama"
        url="/"
        structuredData={organizationSchema}
      />
      <HeroIndustrial />
      <TestimonialsIndustrial />
      <ContactIndustrial />
    </>
  );
};

export default HomePage;